"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: "Selezionare l'orario"
};

exports["default"] = locale;